import React from 'react';
import { handleCheckout } from '../utils/checkout';
export function OfferStack() {
  return <section id="purchase" className="bg-warm-mid py-20 md:py-28 px-4" data-id="element-226">
      <div className="max-w-3xl mx-auto" data-id="element-227">
        {/* Section header */}
        <div className="text-center mb-10" data-id="element-228">
          <p className="font-sans font-bold text-red-500 uppercase tracking-widest text-sm mb-3 flex items-center justify-center gap-2" data-id="element-229"></p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-warm-hero leading-tight mb-3" data-id="element-230">
            Get The <span className="italic text-soft-gold" data-id="element-231">Pawfect</span> Shot
            MegaPack
          </h2>
          <p className="font-sans text-xl md:text-2xl font-bold text-green-600 max-w-2xl mx-auto leading-relaxed" data-id="element-232">
            + all 3 bonuses free today
          </p>
        </div>

        {/* Offer card */}
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-soft-gold/25 shadow-xl" data-id="element-233">
          <h3 className="font-sans text-lg md:text-xl font-bold text-warm-hero mb-6 pb-4 border-b border-gray-200 flex items-center gap-2" data-id="element-234">
            <span data-id="element-235">📦</span> What you'll receive today:
          </h3>

          <ul className="space-y-3 mb-8" data-id="element-236">
            {[{
            text: '6 Dog Photography Books',
            bold: true
          }, {
            text: 'Bonus #1: 30 Sit-Snap-Shoot Cheat Sheets',
            bold: true
          }, {
            text: 'Bonus #2: 7 Lightroom Editing Walkthroughs',
            bold: true
          }, {
            text: 'Bonus #3: Photo Settings & Setup Guide for 119 Dog Photos',
            bold: true
          }, {
            text: 'Beginner-friendly guidance',
            bold: false
          }, {
            text: 'Instant digital access',
            bold: false
          }, {
            text: 'One-time payment',
            bold: false
          }, {
            text: 'Lifetime access',
            bold: false
          }].map((item, index) => <li key={index} className="flex items-center" data-id="element-237">
                <span className="text-green-500 text-lg mr-3 flex-shrink-0" data-id="element-238">
                  ✅
                </span>
                <span className={`font-sans text-base md:text-lg ${item.bold ? 'font-bold text-warm-hero' : 'text-gray-600'}`} data-id="element-239">
                  {item.text}
                </span>
              </li>)}
          </ul>

          {/* Price block */}
          <div className="bg-cream rounded-xl p-6 md:p-8 text-center border border-soft-gold/15 mb-8" data-id="element-240">
            <p className="font-sans text-gray-500 text-base mb-1" data-id="element-241">
              Regular Price:{' '}
              <span className="line-through text-red-400" data-id="element-242">NZD $189.99</span>
            </p>
            <p className="font-sans text-warm-hero text-lg font-bold mb-2 uppercase tracking-wide" data-id="element-243">
              TODAY ONLY:
            </p>
            <p className="font-serif text-5xl md:text-6xl font-bold text-green-600 mb-2" data-id="element-244">
              NZD $24.49
            </p>
            <p className="font-sans text-xs text-gray-400 mt-2" data-id="element-245">
              You'll be charged in your local currency if applicable.
            </p>
          </div>

          {/* Buy button */}
          <button onClick={handleCheckout} className="w-full bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-xl md:text-2xl py-5 px-8 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase mb-5" data-id="element-246">
            👉 GET MY MEGAPACK TODAY
          </button>

          {/* Microcopy */}
          <p className="font-sans text-sm text-gray-500 text-center font-medium" data-id="element-247">
            ✔ Instant access ✔ One-time payment ✔ Digital download ✔
            Lifetime access
          </p>
        </div>
      </div>
    </section>;
}